// Validation regular expressions
export const validationPatterns = {
  hetu: /^[0-9]{6}([+-A])(?:[0-9]+){1,3}[0-9A-Za-z]$/,
  zip: /[0-9]{5}/,
  notEmpty: /^.{2,}$/,
  phoneNumber: /^((90[0-9]{3})?0|\+358\s?)(?!(100|20(0|2(0|[2-3])|9[8-9])|300|600|700|708|75(00[0-3]|(1|2)\d{2}|30[0-2]|32[0-2]|75[0-2]|98[0-2])))(4|50|10[1-9]|20(1|2(1|[4-9])|[3-9])|29|30[1-9]|71|73|75(00[3-9]|30[3-9]|32[3-9]|53[3-9]|83[3-9])|2|3|5|6|8|9|1[3-9])\s?(\d\s?){4,19}\d$/,
}
